module.exports = __webpack_public_path__ + "img/die.74aa8c55.svg";